/**
 * Thai — the source dictionary. Every other language must have exactly these keys
 * (TypeScript enforces it). Tone: warm, calm, like a friend who is a nurse.
 * Safety messages stay clear, but never alarming or repetitive.
 */
export const th = {
  meta: { name: 'ไทย', dateLocale: 'th-TH' },
  common: {
    next: 'ถัดไป', back: 'ย้อนกลับ', save: 'บันทึก', cancel: 'ยกเลิก', close: 'ปิด', done: 'เสร็จแล้ว',
    skip: 'ข้าม', gotIt: 'เข้าใจแล้ว', loading: 'กำลังโหลด…', retry: 'ลองอีกครั้ง',
    times: 'ครั้ง', minutes: 'นาที', hours: 'ชม.', week: 'สัปดาห์ที่', today: 'วันนี้', yesterday: 'เมื่อวาน',
    offline: 'ออฟไลน์อยู่ · บันทึกไว้ในเครื่องแล้ว จะซิงก์ให้เมื่อมีเน็ต',
    saved: 'บันทึกแล้ว', error: 'มีบางอย่างผิดพลาด ลองอีกครั้งนะ', demoBanner: 'โหมดทดลอง · ข้อมูลเก็บในเครื่องนี้เท่านั้น'
  },
  lang: { title: 'เลือกภาษา', subtitle: 'Choose your language', soon: 'เร็ว ๆ นี้' },
  welcome: {
    title: 'Hello DinDin', titleLocal: 'ฮัลโหล ดิ้นดิ้น',
    lead: 'บันทึกทุกครั้งที่ลูกดิ้น และรู้ว่าลูกดิ้นตรงไหน บนท้อง 3D ของคุณแม่เอง',
    start: 'เริ่มใช้งาน', haveAccount: 'มีบัญชีแล้ว เข้าสู่ระบบ', trial: 'ทดลองใช้ทุกฟีเจอร์ฟรี 7 วัน ไม่ต้องผูกบัตร'
  },
  how: {
    title: 'นับลูกดิ้นแบบง่าย ๆ',
    p1t: 'Count to 10', p1: 'ตั้งแต่สัปดาห์ที่ 28 คุณหมอมักแนะนำให้สังเกตว่าลูกดิ้นครบ 10 ครั้งภายใน 2 ชั่วโมง',
    p2t: 'แตะได้ตลอดวัน', p2: 'ลูกดิ้นเมื่อไหร่ แตะบนท้องตรงจุดนั้น แอปจะคิดให้เองว่าครบ 10 ครั้งใน 2 ชั่วโมงหรือยัง',
    p3t: 'หรือนั่งนับแบบตั้งใจ', p3: 'อยากโฟกัส กดเริ่มจับเวลา แล้วนับไปพร้อมกัน',
    note: 'Hello DinDin ช่วยจดบันทึก ไม่ได้แทนคุณหมอ ถ้ารู้สึกว่าลูกดิ้นเปลี่ยนไป โทรคุยกับโรงพยาบาลได้เสมอ',
    consentPrivacy: 'ฉันอายุ 18 ปีขึ้นไป และยอมรับ<a data-action="legal" data-doc="terms">ข้อตกลง</a>และ<a data-action="legal" data-doc="privacy">นโยบายความเป็นส่วนตัว</a>',
    consentHealth: 'ยินยอมให้เก็บข้อมูลการตั้งครรภ์และการดิ้นของลูก เพื่อแสดงสถิติให้ฉันดู'
  },
  due: {
    title: 'กำหนดคลอดวันไหน?', lead: 'ใช้คำนวณอายุครรภ์ แก้ได้ภายหลัง', label: 'วันกำหนดคลอด',
    nowAt: 'ตอนนี้คุณแม่อยู่', weeksDays: 'สัปดาห์ {d} วัน', daysLeft: 'อีก {n} วันถึงกำหนดคลอด', pastDue: 'เลยกำหนดมา {n} วัน',
    early: 'ยังไม่ถึงสัปดาห์ที่ 28 บันทึกได้ตามสบาย พอถึงแล้วค่อยนับทุกวัน',
    errTooFar: 'วันที่ไกลเกินไป ลองเช็คอีกครั้งนะ', errTooPast: 'วันกำหนดคลอดผ่านมานานแล้ว ลองเช็คอีกครั้งนะ'
  },
  names: {
    title: 'เรียกคุณแม่ว่าอะไรดี?', mom: 'ชื่อคุณแม่', momPh: 'เช่น มะลิ',
    baby: 'ชื่อเล่นลูก (ไม่ใส่ก็ได้)', babyPh: 'เช่น น้องถั่ว'
  },
  tryit: {
    title: 'ลองแตะท้องดูสิ', lead: 'แตะตรงไหนก็ได้ เหมือนตอนรู้สึกว่าลูกดิ้น',
    hint: 'ลากนิ้วเพื่อหมุนดูด้านข้าง', great: 'แบบนี้แหละ! 🎉', greatLead: 'ทุกครั้งที่ลูกดิ้น แตะตรงนั้นได้เลย ครั้งนี้เป็นแค่การลอง ยังไม่บันทึก'
  },
  start: {
    welcomeBack: 'กลับมาแล้ว!',
    welcomeBackLead: 'แตะต่อได้เลย หรือกด "ใช้ต่อ" เพื่อเก็บไว้',
    rTie: 'ตอนนี้ยังเท่าๆ กัน จดอีกสักหน่อยจะเริ่มเห็นภาพ',
    step1: 'แตะท้องตรงที่รู้สึกว่าลูกดิ้น',
    step1Sub: 'ไม่ต้องสมัคร ไม่ต้องกรอกอะไร แตะได้เลย',
    step2: 'เมื่อกี้ทำอะไรอยู่? แตะเดียวจดเลย',
    step2More: 'จดแบบละเอียด',
    step2Skip: 'ข้าม ไปดูรายงาน',
    step3: 'ดูว่าลูกชอบดิ้นตรงไหน ช่วงไหน',
    step3Btn: 'ดูรายงานของฉัน ›',
    title: 'ลูกดิ้นตรงไหน แตะตรงนั้นเลย',
    lead: 'สมุดจดลูกดิ้น ลองได้ทันที ไม่ต้องโหลดแอป',
    hint: 'แตะบนท้องตรงที่รู้สึกว่าลูกดิ้น',
    count: 'แตะแล้ว {n} ครั้ง · แตะต่อได้เรื่อยๆ',
    jotBubble: 'เมื่อกี้ทำอะไรอยู่? ลองกด "จด" ดู',
    seeReport: 'ดูรายงาน',
    continue: 'ใช้ต่อ',
    privacyLine: 'สิ่งที่จดอยู่ในเครื่องคุณ · เก็บแค่สถิติการใช้งานแบบไม่ระบุตัวตน · เป็นสมุดจด ไม่ใช่เครื่องมือแพทย์',
    haveAccount: 'มีบัญชีแล้ว? เข้าสู่ระบบ',
    reportTitle: 'รายงานของคุณแม่',
    reportLead: 'จากที่แตะและจดไว้ตอนนี้',
    rTaps: 'ครั้งที่แตะ',
    rNotes: 'ครั้งที่จด',
    rTagsTitle: 'ก่อนลูกดิ้น คุณแม่ทำอะไรอยู่',
    rTagsEmpty: 'ยังไม่ได้จด ลองกด "จด" ดูนะ',
    rNotesWritten: 'เขียนโน้ต {n} ครั้ง',
    reportMore: 'ยิ่งจดหลายวัน ยิ่งเห็นว่าลูกชอบดิ้นตรงไหน ช่วงไหน'
  },
  account: {
    title: 'เก็บข้อมูลไว้ให้ปลอดภัย', lead: 'สร้างบัญชีเพื่อไม่ให้ข้อมูลหายเวลาเปลี่ยนมือถือ และดูได้ทุกเครื่อง',
    loginTitle: 'ยินดีต้อนรับกลับมา', welcomeBack: 'ยินดีต้อนรับกลับมา ใช้ข้อมูลเดิมในบัญชีของคุณ', loginLead: 'ใส่อีเมลที่ใช้สมัครไว้',
    guestNudge: 'ตอนนี้ข้อมูลอยู่ในเครื่องนี้เท่านั้น', guestNudgeCta: 'เก็บเข้าบัญชีฟรี ›', guestCardLead: 'ตอนนี้ข้อมูลที่จดไว้อยู่ในมือถือเครื่องนี้เท่านั้น ถ้าล้างเบราว์เซอร์หรือเปลี่ยนเครื่องจะหาย สร้างบัญชีด้วยอีเมล ข้อมูลทั้งหมดจะย้ายเข้าบัญชีให้', guestCardCta: 'เก็บข้อมูลเข้าบัญชี (ฟรี)', savedToAccount: 'ข้อมูลอยู่ในบัญชีแล้ว เปิดเครื่องไหนก็เห็น',
    google: 'ใช้บัญชี Google', or: 'หรือ', email: 'อีเมล', emailPh: 'you@example.com', sendCode: 'ส่งรหัสไปที่อีเมล',
    codeSent: 'ส่งรหัส 6 หลักไปที่ {email} แล้ว', code: 'รหัสจากอีเมล', verify: 'ยืนยัน', resend: 'ส่งรหัสใหม่',
    changeEmail: 'เปลี่ยนอีเมล', badEmail: 'อีเมลไม่ถูกต้อง', badCode: 'รหัสไม่ถูกต้องหรือหมดอายุ',
    demoTitle: 'โหมดทดลอง', demoLead: 'เวอร์ชันนี้ยังไม่เชื่อมเซิร์ฟเวอร์ ข้อมูลจะเก็บในเครื่องนี้เท่านั้น', demoContinue: 'ใช้ต่อในเครื่องนี้'
  },
  hospital: {
    title: 'เบอร์โรงพยาบาลที่ฝากครรภ์', lead: 'เก็บไว้ในแอป เผื่ออยากโทรถามเรื่องลูกดิ้นได้ในปุ่มเดียว',
    label: 'เบอร์โทร (ไม่ใส่ก็ได้)', ph: 'เช่น 02 123 4567', invalid: 'ใช้ได้เฉพาะตัวเลข เว้นวรรค + - ( )', finish: 'เริ่มใช้งาน'
  },
  home: {
    morning: 'อรุณสวัสดิ์', afternoon: 'สวัสดีตอนบ่าย', evening: 'สวัสดีตอนเย็น',
    who: 'คุณแม่{name}', whoBaby: 'คุณแม่{name} & {baby}',
    idleTitle: 'ลูกดิ้นเมื่อไหร่ แตะบนท้องได้เลย', idleLead: 'แอปจะนับให้ว่าครบ 10 ครั้งใน 2 ชั่วโมงหรือยัง',
    countingTitle: '{n} จาก 10 ครั้ง', countingLead: 'เหลือเวลาอีก {t} ในรอบ 2 ชั่วโมงนี้',
    reachedTitle: 'ครบ 10 ครั้งแล้ว', reachedLead: 'ใช้เวลา {m} นาที',
    todayDone: 'วันนี้ครบ 10 แล้ว ✓', focus: 'นับแบบจับเวลา', undo: 'ย้อน 1', undone: 'ลบครั้งล่าสุดแล้ว',
    todayCount: 'วันนี้ {n} ครั้ง', streak: 'นับต่อเนื่อง {n} วัน', saveAccount: 'สร้างบัญชีเพื่อเก็บข้อมูล',
    kickSaved: 'บันทึกแล้ว · ครั้งที่ {n}'
  },
  coach: {
    s1t: 'แตะบนท้องเมื่อลูกดิ้น', s1: 'แตะตรงจุดที่รู้สึก ลากนิ้วเพื่อหมุนดูด้านข้าง',
    s2t: 'แอปนับให้เอง', s2: 'ดูตรงนี้ว่าครบ 10 ครั้งใน 2 ชั่วโมงหรือยัง ไม่ต้องจับเวลาเอง',
    s3t: 'อยากนั่งนับจริงจัง', s3: 'กดเพื่อเริ่มจับเวลา 2 ชั่วโมง แล้วนับไปพร้อมกัน',
    step: '{i} / {n}'
  },
  session: {
    title: 'นับแบบจับเวลา', tapHint: 'แตะตรงจุดที่ลูกดิ้น', end: 'จบการนับ', leave: 'ออกโดยไม่บันทึก?',
    leaveLead: 'การดิ้น {n} ครั้งในรอบนี้จะไม่ถูกเก็บ', leaveOk: 'ออก', emptyEnd: 'ยังไม่ได้แตะเลย ออกเลยไหม?',
    note: 'โน้ต (ไม่ใส่ก็ได้)', notePh: 'เช่น หลังมื้อเย็น ลูกดิ้นแรง',
    doneTitle: 'ครบ 10 ครั้งแล้ว!', doneLead: 'ใช้เวลา {m} นาที',
    partialTitle: 'บันทึก {n} ครั้ง', partialLead: 'เก็บไว้ในสมุดบันทึกแล้ว',
    mins: 'นาที', mainZone: 'ตำแหน่งหลัก', backHome: 'กลับหน้าหลัก'
  },
  help: {
    link: 'รู้สึกว่าลูกดิ้นน้อยลงกว่าปกติ?',
    title: 'ติดต่อแพทย์ได้เสมอ',
    body: 'ถ้ารู้สึกว่าลูกดิ้นน้อยลงหรือเปลี่ยนไปจากปกติ ติดต่อแพทย์หรือโรงพยาบาลที่ฝากครรภ์ได้ทันที ไม่ต้องรอถึงวันนัด',
    callHospital: 'โทรหาโรงพยาบาล', addHospital: 'ใส่เบอร์โรงพยาบาล', emergency: 'ฉุกเฉินโทร 1669',
    disclaimer: 'แอปนี้เป็นสมุดจดบันทึก ไม่ได้ตรวจหรือวินิจฉัยความผิดปกติ'
  },
  zones: { upper_left: 'ซ้ายบน', upper_right: 'ขวาบน', lower_left: 'ซ้ายล่าง', lower_right: 'ขวาล่าง' },
  stats: {
    title: 'สถิติ', tabToday: 'วันนี้', tabWeek: '7 วัน', tabZones: 'ตำแหน่ง', tabHours: 'ช่วงเวลา',
    emptyTitle: 'ยังไม่มีข้อมูล', emptyLead: 'แตะท้องครั้งแรกแล้วสถิติจะขึ้นที่นี่',
    total: 'ครั้งทั้งหมด', reached: 'ครบ 10 ใน 2 ชม.', notYet: 'ยังไม่ครบ', reachedIn: 'ครบใน {m} นาที',
    moreThan: 'มากกว่าเมื่อวาน {n} ครั้ง', lessThan: 'น้อยกว่าเมื่อวาน {n} ครั้ง', same: 'เท่ากับเมื่อวาน',
    daily: 'การดิ้นรายวัน', avg: 'เฉลี่ยต่อวัน', daysReached: 'วันที่ครบ 10',
    whereTitle: 'ลูกดิ้นตรงไหนบ่อย', top: 'บ่อยสุด: {z} ({p}%)', noZone: 'ยังไม่มีข้อมูลตำแหน่ง',
    zoneNote: 'ตำแหน่งที่ดิ้นช่วยให้คุยกับคุณหมอได้ง่ายขึ้น แต่ไม่ใช่การบอกท่าของลูก',
    hoursTitle: 'ลูกตื่นช่วงไหน', peak: 'ดิ้นบ่อยช่วง {h}', sessions: 'การนับแบบจับเวลา',
    locked: 'ฟีเจอร์ Premium', unlock: 'ดู Premium'
  },
  profile: {
    title: 'โปรไฟล์', pregnancy: 'การตั้งครรภ์', dueDate: 'กำหนดคลอด', mom: 'ชื่อคุณแม่', baby: 'ชื่อเล่นลูก', notSet: 'ยังไม่ได้ใส่',
    hospital: 'เบอร์โรงพยาบาล', app: 'การใช้งาน', language: 'ภาษา', sound: 'เสียงตอนแตะ',
    plan: 'แพ็กเกจ', trialLeft: 'ทดลองใช้ · เหลือ {n} วัน', premiumUntil: 'Premium ถึง {d}', premiumForever: 'Premium · ปลดล็อกถาวร', free: 'ฟรี', upgrade: 'อัปเกรดเป็น Premium',
    account: 'บัญชี', signedInAs: 'เข้าสู่ระบบด้วย', signOut: 'ออกจากระบบ', signOutLead: 'ข้อมูลยังอยู่ในบัญชี เข้าสู่ระบบใหม่เมื่อไหร่ก็เห็น',
    data: 'ข้อมูลของฉัน', export: 'ดาวน์โหลดข้อมูลทั้งหมด', delete: 'ลบบัญชีและข้อมูล',
    deleteLead: 'ข้อมูลการตั้งครรภ์และการนับทั้งหมดจะถูกลบถาวร ย้อนกลับไม่ได้', deleteOk: 'ลบถาวร', deleted: 'ลบข้อมูลเรียบร้อย',
    about: 'เกี่ยวกับ', terms: 'ข้อตกลงการใช้งาน', privacy: 'นโยบายความเป็นส่วนตัว', notMedical: 'Hello DinDin ไม่ใช่อุปกรณ์การแพทย์',
    demoTools: 'เครื่องมือทดสอบ (โหมดทดลองเท่านั้น)', seed: 'เติมข้อมูลตัวอย่าง 7 วัน', expire: 'จำลอง: ช่วงทดลองหมด', version: 'เวอร์ชัน {v}'
  },
  paywall: {
    title: 'ปลดล็อกทุกฟีเจอร์', trialLead: 'ตอนนี้ใช้ได้ทุกฟีเจอร์ฟรี เหลืออีก {n} วัน',
    endedTitle: 'ช่วงทดลองครบ 7 วันแล้ว', endedLead: 'นับลูกดิ้นได้ฟรีตลอด อัปเกรดเพื่อดูตำแหน่งและสถิติย้อนหลัง',
    f1: 'บันทึกตำแหน่งที่ลูกดิ้นบนท้อง 3D', f2: 'สถิติย้อนหลัง แผนที่ตำแหน่ง และช่วงเวลาที่ลูกตื่น', f3: 'นับลูกดิ้น จดบันทึก และปุ่มโทรหาโรงพยาบาล ฟรีตลอด', f4: 'สมุดบันทึก DinDin Wrapped ไว้แชร์ (เร็ว ๆ นี้)',
    lifetime: 'ปลดล็อกถาวร', lifetimeSub: 'จ่ายครั้งเดียว ใช้ได้ตลอดในบัญชีนี้',
    noAuto: 'ไม่มีรายเดือน ไม่ตัดเงินซ้ำ · จ่ายด้วย PromptPay หรือบัตร',
    buy: 'ชำระเงิน', later: 'ไว้ทีหลัง', continueFree: 'ใช้แบบฟรีต่อ', soon: 'เปิดให้ชำระเงินเร็ว ๆ นี้', signInToBuy: 'สร้างบัญชีก่อนซื้อ (ข้อมูลย้ายตามไปด้วย)',
    thanks: 'ขอบคุณค่ะ! เปิดใช้ Premium แล้ว', pending: 'กำลังยืนยันการชำระเงิน…',
    heroCount: '{baby}ทักแม่ไปแล้ว {n} ครั้ง', heroDefault: 'เก็บทุกการทักทายของลูก', heroSub: 'อยากรู้ไหมว่า{baby}ชอบดิ้นตรงไหน ตอนไหน', babyFallback: 'ลูก',
    favSpot: 'มุมโปรด', favHour: 'ดิ้นบ่อยสุด', hourFmt: '{h}:00 น.', sample: 'ตัวอย่าง', soonChip: 'เร็ว ๆ นี้',
    cardOwl: 'ลูกเป็นสายไหน', cardBook: 'สมุดบันทึกตอนคลอด', cardFilm: 'หนังเรื่องของลูก', cardTimelapse: 'ท้องโตทีละสัปดาห์',
    trySamples: 'แตะเพื่อดูตัวอย่างสิ่งที่จะได้', sampleNote: 'ตัวอย่างจากข้อมูลจำลอง ของจริงจะสร้างจากการทักทายของลูกคุณเอง',
    pOwl: 'นกฮูกน้อย', pOwlQ: '“หนูชอบดิ้นตอนสามทุ่มนะแม่”', pRooster: 'ไก่ขันเช้า', pRoosterQ: '“ตื่นก่อนแม่ทุกวันเลย”', pCat: 'แมวงีบกลางวัน', pCatQ: '“ชอบดิ้นหลังแม่กินข้าวเที่ยง”',
    colFree: 'ฟรี', colPremium: 'Premium', rowCount: 'นับลูกดิ้น จดบันทึก โมเมนต์สำคัญ', rowCall: 'ปุ่มโทรหาโรงพยาบาล',
    rowSpot: 'ตำแหน่งที่ลูกดิ้นบนท้อง 3D', rowStats: 'สถิติ + ช่วงเวลาที่ลูกตื่น', rowWrapped: 'สมุดบันทึก + หนังเรื่องของลูก',
    letterTitle: 'จากคนทำ', letter: '', letterSign: '— ดิว', seeAll: 'ดูสิ่งที่ได้ทั้งหมด', yours: 'Premium ของคุณ'
  },
  moments: {
    section: 'โมเมนต์สำคัญ', notSet: 'ยังไม่ได้บันทึก', saved: 'บันทึกแล้ว', savedWeek: 'สัปดาห์ที่ {n}',
    first_kick: 'ครั้งแรกที่ลูกทักแม่', partner_felt: 'ครั้งแรกที่คนอื่นได้สัมผัสลูกดิ้น', last_before_birth: 'ครั้งสุดท้ายก่อนเจอกัน',
    lead_first_kick: 'จำได้ไหมว่าตอนนั้นสัปดาห์ไหน ตรงไหนของท้อง ใส่เท่าที่จำได้ก็พอ',
    lead_partner_felt: 'วันที่มีคนวางมือบนท้อง แล้วรู้สึกว่าลูกดิ้นเป็นครั้งแรก',
    lead_last_before_birth: 'การทักทายครั้งสุดท้ายในท้อง ก่อนวันที่ได้เจอกัน',
    note_first_kick: 'เช่น วันนั้นแม่กำลังดูหนังกับพ่อ', note_partner_felt: 'เช่น พ่อวางมือแล้วตกใจ หัวเราะกันทั้งบ้าน', note_last_before_birth: 'เช่น คืนก่อนไปโรงพยาบาล',
    week: 'สัปดาห์ที่', weekN: 'สัปดาห์ที่ {n}', weekUnknown: 'จำไม่ได้', spot: 'ตรงไหนของท้อง (ไม่ใส่ก็ได้)',
    spotHint: 'แตะบนท้องตรงจุดที่จำได้', spotSet: 'แตะใหม่เพื่อย้ายจุด',
    save: 'เก็บไว้ในสมุด', savedToast: 'เก็บไว้ในสมุดแล้ว 💛', remove: 'ลบโมเมนต์นี้', removed: 'ลบแล้ว'
  },
  journal: {
    button: 'จด', title: 'ก่อนลูกดิ้น คุณแม่ทำอะไรอยู่?', lead: 'ไม่ต้องจดทุกครั้ง จดเฉพาะตอนที่สังเกตเห็น · เลือกได้หลายอัน',
    nudge: 'ลูกดิ้นแล้ว! เมื่อกี้ทำอะไรอยู่? กดจดไว้ได้นะ ✏️', firstSaved: 'จดไว้แล้ว! ยิ่งจดบ่อย สมุดตอนคลอดยิ่งรู้ใจน้อง 💛',
    noteLabel: 'จดเพิ่ม (ไม่ใส่ก็ได้)', notePh: 'เช่น พ่อร้องเพลงแล้วลูกเตะใหญ่เลย',
    save: 'บันทึก', saved: 'จดไว้แล้ว 💛', recent: 'ที่จดไว้ล่าสุด', empty: 'ยังไม่ได้จดอะไร',
    delete: 'ลบ', deleted: 'ลบแล้ว'
  },
  tags: {
    after_meal: 'หลังกินข้าว', sweet_cold: 'ของหวาน/ของเย็น', music: 'ฟังเพลง', voice: 'คุยกับลูก',
    resting: 'นั่งพัก', bedtime: 'ก่อนนอน', walking: 'เดิน', bath: 'อาบน้ำ'
  },
  nav: { home: 'หน้าหลัก', stats: 'สถิติ', profile: 'โปรไฟล์' },
  legal: {
    draft: 'ฉบับร่าง · รอผู้เชี่ยวชาญด้านกฎหมายตรวจก่อนเปิดใช้จริง',
    terms: 'Hello DinDin เป็นเครื่องมือช่วยบันทึกการดิ้นของทารกในครรภ์ ไม่ใช่อุปกรณ์การแพทย์ และไม่ให้คำวินิจฉัย ผู้ใช้ต้องมีอายุ 18 ปีขึ้นไป Premium เป็นการจ่ายครั้งเดียว ปลดล็อกถาวรในบัญชีที่ซื้อ ไม่มีค่าบริการรายเดือน หากวันหนึ่งบริการต้องปิดตัว เราจะแจ้งล่วงหน้าและให้ดาวน์โหลดข้อมูลทั้งหมดได้',
    privacy: 'เราเก็บเฉพาะข้อมูลที่จำเป็น: อีเมล ชื่อที่คุณตั้ง วันกำหนดคลอด เบอร์โรงพยาบาล (ถ้าใส่) เวลา/ตำแหน่งที่บันทึกการดิ้น และสิ่งที่คุณจดไว้ (แท็กและโน้ต) ข้อมูลเก็บบนเซิร์ฟเวอร์ในสิงคโปร์ เข้ารหัสระหว่างส่ง เราไม่ขายหรือแชร์ข้อมูลเพื่อการโฆษณา คุณดาวน์โหลดหรือลบข้อมูลทั้งหมดได้เองในหน้าโปรไฟล์ นอกจากนี้เราเก็บสถิติการใช้งานแบบไม่ระบุตัวตนเพื่อปรับปรุงแอป ได้แก่ ชื่อขั้นตอนหรือปุ่มที่กด หน้าที่เปิด ช่องทางที่เข้ามา (เช่น TikTok) และรหัสสุ่มของเครื่อง โดยไม่รวมตำแหน่งหรือเวลาที่ลูกดิ้น สิ่งที่คุณจด ชื่อ หรือวันกำหนดคลอด'
  }
};

export type Dict = typeof th;
